import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LoginComponent} from'./shared/components/login/login.component'
import{SignupComponent}from'./mentor/components/signup/signup.component'
import{SignupscholarComponent}from'./scholar/components/signupscholar/signupscholar.component'
import {LandingPageComponent} from'./shared/components/landingPage/landing-page.component'
import{GlobalErrorComponent}from'./global-error.component'
import{VerifyEmailComponent}from'./mentor/components/verify-email/verify-email.component'
import{AdminAuthInterceptor}from'./admin/services/admin-interceptor.service'
import{MentorAuthInterceptor}from'./mentor/services/mentor-interceptor.service'
import{ScholarAuthInterceptor}from'./scholar/services/scholar-interceptor.service'
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import{SharedService}from'./shared/services/shared.service'
import { ResetPasswordComponent } from './shared/reset-password/reset-password.component';
import { UpdatePasswordComponent } from './shared/components/update-password/update-password.component';
const appRoutes: Routes = [
  {path:'mentor',loadChildren:'./mentor/mentor.module#MentorModule'},
  {path:'scholar',loadChildren:'./scholar/scholar.module#ScholarModule'},
  {path:'co-ordinator',loadChildren:'./admin/admin.module#AdminModule'},
  {path:"",component:LandingPageComponent},
  {path:"login/:type",component:LoginComponent},
  {path:"register/mentor",component:SignupComponent},
  {path:'register/scholar',component:SignupscholarComponent},
  {path:'error', component: GlobalErrorComponent},
  {path:'verify/mentor/:token',component:VerifyEmailComponent},
  {path:'reset-password',component:ResetPasswordComponent},
  {path:'update-password/:token',component:UpdatePasswordComponent},
  {path:'**',redirectTo:""}

];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
  providers:[{provide:HTTP_INTERCEPTORS,useClass:AdminAuthInterceptor,multi:true},
              {provide:HTTP_INTERCEPTORS,useClass:MentorAuthInterceptor,multi:true},
              {provide:HTTP_INTERCEPTORS,useClass:ScholarAuthInterceptor,multi:true}]
})
export class AppRoutingModule { }
